import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  InputGroupAddon,
  Button,
  Table
} from "reactstrap";
import qs from "query-string";
import Switch from "react-toggle-switch";
import parseDate from "../../helpers/parseDate";
import alphabetizeBy from "../../helpers/alphabetizeBy";
import LoaderSpinner from "../Widgets/LoaderSpinner";
import ConfirmDelete from "../Components/ConfirmDelete";
import authProtection from "../../HOCs/authProtection";
import withAlertTimeout from "../../HOCs/withAlertTimeout";
import Alert from "../Widgets/Alert";
import CopyInventoryModal from "../Components/CopyInventoryModal";

class CopyInventory extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sourceQuery: "",
      targetQuery: "",
      showModal: false,
      selectedBusinesses: {
        sourceBusiness: null,
        targetBusiness: null
      },
      copying: false,
      errorMessage: "Something went wrong, please try again"
    };

    this.onQueryInput = this.onQueryInput.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.copyInventory = this.copyInventory.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.isSuperAdmin = false;
  }

  componentDidMount() {
    document.querySelector("#business-name-input").focus();

    const user = JSON.parse(sessionStorage.getItem("user"));
    if (
      user.privyData.group.goNation.some(item => item.name === "SuperAdmin")
    ) {
      this.isSuperAdmin = true;
    }
  }

  onQueryInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  async fetchBusinesses() {
    const { sourceQuery, targetQuery } = this.state;

    const sourcePromise = axios.get(
      `/api/proxy/v2/businesses?slug=${sourceQuery}`
    );
    const targetPromise = axios.get(
      `/api/proxy/v2/businesses?slug=${targetQuery}`
    );

    try {
      const [sourceBusiness, targetBusiness] = await Promise.all([
        sourcePromise,
        targetPromise
      ]);
      return {
        sourceBusiness: sourceBusiness.data,
        targetBusiness: targetBusiness.data
      };
    } catch (e) {
      this.setState(
        { errorMessage: "Please enter 2 valid business slugs" },
        this.props.showFailure
      );
      return null;
    }
  }

  async onSubmit() {
    try {
      const businesses = await this.fetchBusinesses();
      if (businesses) {
        const { sourceBusiness, targetBusiness } = businesses;
        if (sourceBusiness.business.id === targetBusiness.business.id) {
          this.setState(
            { errorMessage: "Please select 2 unique businesses " },
            this.props.showFailure
          );
        } else {
          this.setState({
            showModal: true,
            selectedBusinesses: { ...businesses },
            errorMessage: "Something went wrong, please try again"
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  onSuccess() {
    this.closeModal();
    this.props.showSuccess();
  }

  copyInventory() {
    const { sourceBusiness, targetBusiness } = this.state.selectedBusinesses;
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    this.setState({ copying: true });

    axios
      .post(
        `api/proxy/v2/businesses/${sourceBusiness.business.id}/copyInventory/${
          targetBusiness.business.id
        }`,
        {},
        { headers }
      )
      .then(this.onSuccess)
      .catch(console.log)
      .finally(() => {
        this.setState({ copying: false });
      });
  }

  render() {
    const { sourceBusiness, targetBusiness } = this.state.selectedBusinesses;

    return [
      <CopyInventoryModal
        key="amodal"
        isOpen={this.state.showModal}
        sourceBusiness={sourceBusiness}
        targetBusiness={targetBusiness}
        onConfirm={this.copyInventory}
        close={this.closeModal}
        copying={this.state.copying}
      />,
      <Row>
        <Col xs="12">
          <Card>
            <CardHeader>Copy Business Inventory</CardHeader>
            <CardBody>
              {<Alert active={this.props.success} message="Copy Successful" />}
              {
                <Alert
                  type="danger"
                  active={this.props.failure}
                  message={this.state.errorMessage}
                />
              }
              <FormGroup>
                <Label htmlFor="business name">Source Business Slug</Label>
                <Input
                  type="search"
                  name="sourceQuery"
                  id="business-name-input"
                  placeholder="e.g. gonation-restaurant"
                  value={this.state.sourceQuery}
                  onChange={this.onQueryInput}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="business name">Target Business Slug</Label>
                <Input
                  type="search"
                  name="targetQuery"
                  placeholder="e.g. woodmont-pizza"
                  value={this.state.targetQuery}
                  onChange={this.onQueryInput}
                />
              </FormGroup>
              <div className="form-actions">
                <Button
                  onClick={this.onSubmit}
                  type="submit"
                  color="primary"
                  disabled={this.state.isSubmitting}
                >
                  Submit
                </Button>
              </div>
            </CardBody>
          </Card>
          {this.state.isSubmitting && <LoaderSpinner />}
        </Col>
      </Row>
    ];
  }
}

export default authProtection(withAlertTimeout(CopyInventory));



// WEBPACK FOOTER //
// ./src/views/Pages/CopyInventory.js